import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "List",
  [
    [
      "path",
      {
        d: "M3.5 5C2.94772 5 2.5 5.44772 2.5 6C2.5 6.55228 2.94772 7 3.5 7H3.51C4.06228 7 4.51 6.55228 4.51 6C4.51 5.44772 4.06228 5 3.51 5H3.5ZM8.5 5C7.94772 5 7.5 5.44772 7.5 6C7.5 6.55228 7.94772 7 8.5 7H21.5C22.0523 7 22.5 6.55228 22.5 6C22.5 5.44772 22.0523 5 21.5 5H8.5ZM8.5 11C7.94772 11 7.5 11.4477 7.5 12C7.5 12.5523 7.94772 13 8.5 13H21.5C22.0523 13 22.5 12.5523 22.5 12C22.5 11.4477 22.0523 11 21.5 11H8.5ZM7.5 18C7.5 17.4477 7.94772 17 8.5 17H21.5C22.0523 17 22.5 17.4477 22.5 18C22.5 18.5523 22.0523 19 21.5 19H8.5C7.94772 19 7.5 18.5523 7.5 18ZM2.5 12C2.5 11.4477 2.94772 11 3.5 11H3.51C4.06228 11 4.51 11.4477 4.51 12C4.51 12.5523 4.06228 13 3.51 13H3.5C2.94772 13 2.5 12.5523 2.5 12ZM3.5 17C2.94772 17 2.5 17.4477 2.5 18C2.5 18.5523 2.94772 19 3.5 19H3.51C4.06228 19 4.51 18.5523 4.51 18C4.51 17.4477 4.06228 17 3.51 17H3.5Z",
      },
    ],
  ],
  "currentColor"
);
